import { Link } from 'react-router-dom';

/**
 * Política de Cookies — LSSI-CE (Ley 34/2002) España
 * Solo cookies técnicas → exentas de consentimiento previo
 */
const PoliticaCookies = () => {
    const sectionStyle = {
        marginBottom: '2rem'
    };

    const headingStyle = {
        fontSize: '1.3rem',
        fontWeight: 700,
        color: '#f1f5f9',
        marginBottom: '0.75rem',
        borderBottom: '1px solid rgba(56, 189, 248, 0.15)',
        paddingBottom: '0.5rem'
    };

    const textStyle = {
        color: '#94a3b8',
        lineHeight: 1.7,
        fontSize: '0.95rem',
        marginBottom: '0.75rem'
    };

    const listStyle = {
        color: '#94a3b8',
        lineHeight: 1.8,
        paddingLeft: '1.5rem',
        fontSize: '0.95rem',
        marginBottom: '0.75rem'
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '1rem',
        fontSize: '0.9rem'
    };

    const thStyle = {
        textAlign: 'left',
        padding: '0.6rem 0.75rem',
        borderBottom: '1px solid rgba(56, 189, 248, 0.2)',
        color: '#e2e8f0',
        fontWeight: 600,
        background: 'rgba(56, 189, 248, 0.05)'
    };

    const tdStyle = {
        padding: '0.6rem 0.75rem',
        borderBottom: '1px solid rgba(148, 163, 184, 0.1)',
        color: '#94a3b8'
    };

    return (
        <div>
            <h1 style={{
                fontSize: '1.8rem',
                fontWeight: 800,
                color: '#f8fafc',
                marginBottom: '0.5rem'
            }}>
                Política de Cookies
            </h1>
            <p style={{ color: '#64748b', fontSize: '0.85rem', marginBottom: '2rem' }}>
                Última actualización: 11 de marzo de 2026
            </p>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>1. ¿Qué son las cookies?</h2>
                <p style={textStyle}>
                    Las cookies son pequeños archivos de texto que los sitios web almacenan en
                    tu navegador. Se utilizan para recordar información sobre tu visita, como
                    tu idioma preferido o tu sesión de usuario.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>2. Cookies que utilizamos</h2>
                <p style={textStyle}>
                    TUVISA Calendar utiliza <strong>exclusivamente cookies técnicas</strong>,
                    necesarias para el funcionamiento básico de la aplicación. No utilizamos
                    cookies de análisis, publicidad ni seguimiento.
                </p>

                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={thStyle}>Nombre</th>
                            <th style={thStyle}>Tipo</th>
                            <th style={thStyle}>Duración</th>
                            <th style={thStyle}>Finalidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ ...tdStyle, fontFamily: 'monospace', color: '#38bdf8' }}>auth_token</td>
                            <td style={tdStyle}>Técnica (HttpOnly)</td>
                            <td style={tdStyle}>8 horas</td>
                            <td style={tdStyle}>Mantener tu sesión iniciada de forma segura</td>
                        </tr>
                    </tbody>
                </table>

                <div style={{
                    padding: '0.75rem 1rem',
                    borderRadius: '0.5rem',
                    background: 'rgba(34, 197, 94, 0.08)',
                    border: '1px solid rgba(34, 197, 94, 0.15)',
                    marginTop: '0.5rem'
                }}>
                    <p style={{ color: '#86efac', fontSize: '0.85rem', margin: 0 }}>
                        ✅ <strong>Exenta de consentimiento previo:</strong> Según el artículo 22.2 de la
                        LSSI-CE, las cookies técnicas estrictamente necesarias no requieren consentimiento
                        del usuario, aunque sí es obligatorio informar de su existencia.
                    </p>
                </div>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>3. Almacenamiento local (localStorage)</h2>
                <p style={textStyle}>
                    Además de la cookie de autenticación, la aplicación utiliza el almacenamiento
                    local del navegador (<code style={{ color: '#38bdf8' }}>localStorage</code>)
                    para guardar:
                </p>
                <ul style={listStyle}>
                    <li><strong>Token de sesión</strong> (en la versión Android/APK, como alternativa a las cookies).</li>
                    <li><strong>Preferencias de la interfaz</strong> (como el tema visual o filtros seleccionados).</li>
                    <li><strong>Token de notificaciones push</strong> (para recibir alertas en el navegador).</li>
                </ul>
                <p style={textStyle}>
                    Estos datos se almacenan localmente en tu dispositivo y no son accesibles
                    por terceros.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>4. Cookies de terceros</h2>
                <p style={textStyle}>
                    <strong>No utilizamos cookies de terceros.</strong> No empleamos Google Analytics,
                    Facebook Pixel, ni ningún otro servicio de seguimiento o publicidad.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>5. ¿Cómo desactivar las cookies?</h2>
                <p style={textStyle}>
                    Puedes configurar tu navegador para rechazar cookies. Sin embargo, dado
                    que nuestra cookie es necesaria para la autenticación, <strong>no podrás
                    iniciar sesión</strong> si la bloqueas.
                </p>
                <p style={textStyle}>
                    Para gestionar las cookies en tu navegador:
                </p>
                <ul style={listStyle}>
                    <li><strong>Chrome:</strong> Configuración → Privacidad y seguridad → Cookies</li>
                    <li><strong>Firefox:</strong> Opciones → Privacidad y seguridad → Cookies</li>
                    <li><strong>Safari:</strong> Preferencias → Privacidad → Cookies</li>
                    <li><strong>Edge:</strong> Configuración → Cookies y permisos de sitio</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>6. Más información</h2>
                <p style={textStyle}>
                    Para cualquier duda sobre nuestra política de cookies, puedes escribirnos
                    a{' '}
                    <a href="mailto:info@xerp.es" style={{ color: '#38bdf8' }}>info@xerp.es</a>.
                </p>
                <p style={textStyle}>
                    Consulta también nuestra{' '}
                    <Link to="/privacidad" style={{ color: '#38bdf8' }}>Política de Privacidad</Link>{' '}
                    para información completa sobre el tratamiento de datos personales.
                </p>
            </section>
        </div>
    );
};

export default PoliticaCookies;
